import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import {
  MenuItem
} from 'react-pro-sidebar';
import CustomSubMenu from '../CustomSubMenu';
import {ChecklistRtlRounded, SendRounded, SummarizeRounded} from "@mui/icons-material"; // Az újrafelosztott komponens

const ReservationCheckSubMenu = ({ location, collapsed, navigate }: { location: any; collapsed: boolean; navigate: any }) => {
  const menuItems = [
    <MenuItem
      key="reservation-check"
      icon={<SendRounded />}
      onClick={(event: any) => {
        if (event.metaKey || event.ctrlKey) {
          window.open(`/reservation-check`, '_blank');
        } else {
          navigate(`/reservation-check`);
        }
      }}
    >
      Send reservation check
    </MenuItem>,
    <MenuItem
      key="reservation-past"
      icon={<SummarizeRounded />}
      onClick={(event: any) => {
        if (event.metaKey || event.ctrlKey) {
          window.open(`/admin/reservation-summaries`, '_blank');
        } else {
          navigate(`/admin/reservation-summaries`);
        }
      }}
    >
      Past reservation checks
    </MenuItem>,
  ];

  // Popper items (összehúzott nézet esetén)
  const popperItems = [
    <ListItemButton
      key="reservation-check"
      onClick={(event: any) => {
        if (event.metaKey || event.ctrlKey) {
          window.open(`/reservation-check`, '_blank');
        } else {
          navigate(`/reservation-check`);
        }
      }}
    >
      <ListItemIcon>
        <SendRounded />
      </ListItemIcon>
      <ListItemText primary="Send reservation check" />
    </ListItemButton>,
    <ListItemButton
      key="reservation-past"
      onClick={(event: any) => {
        if (event.metaKey || event.ctrlKey) {
          window.open(`/admin/reservation-summaries`, '_blank');
        } else {
          navigate(`/admin/reservation-summaries`);
        }
      }}
    >
      <ListItemIcon>
        <SummarizeRounded />
      </ListItemIcon>
      <ListItemText primary="Past reservation checks" />
    </ListItemButton>,
  ];

  return (
    <CustomSubMenu
      props={{
        location: location,
        collapsed: collapsed,
        label: 'Send reservation check',
        icon: <ChecklistRtlRounded />,
        items: menuItems,
        popperItems: popperItems,
      }}
    />
  );
};

export default ReservationCheckSubMenu;
